<script>

import DatePicker from "@/components/form/DatePicker.vue";
import FileInput from "@/components/form/FileInput.vue";

export default {
    components: {FileInput, DatePicker},

    props: ['invoice'],

    data() {
        return {
            date: null,
            saved: false,
            errors: {},
            loading: false,
            loadingCompanies: false,
            companies: [],
            data: {
                company_id: this.invoice?.company_id,
                issue_date: this.invoice?.issue_date,
                type: this.invoice?.type,
                net_amount: this.invoice?.net_amount,
                gross_amount: this.invoice?.gross_amount,
                invoice_number: this.invoice?.invoice_number,
            },
            controller: {
                load: null,
                save: null
            },
            typeOptions: ['cost', 'income'],
            file: null,

        }
    },

    methods: {
        save() {
            this.loading = true;
            this.controller.save = new AbortController();

            let data = new FormData();
            let issueDate = this.data.issue_date;
            if (this.data.issue_date && this.data.issue_date instanceof Date) {
                issueDate = this.data.issue_date.toISOString().split('T')[0];
            }
            data.append('company_id', this.data.company_id);
            data.append('issue_date', issueDate);
            data.append('type', this.data.type);
            data.append('invoice_number', this.data.invoice_number);
            data.append('net_amount', this.data.net_amount);
            data.append('gross_amount', this.data.gross_amount);

            if (this.file) {
                data.append('file', this.file);
            }

            let url = '/invoices';
            if (this.invoice?.id) {
                url = '/invoices/' + this.invoice.id;
                data.append('_method', 'PUT');
            }
            axios.post(url, data, {
                signal: this.controller.save.signal
            }).then(response => {
                this.saved = true;
                this.close();
            }).catch(data => {
                this.errors = data.response?.data?.errors || {};
            }).finally(() => {
                this.loading = false;
            })
        },
        loadCompanies() {
            if (this.controller.load) {
                this.controller.load.abort();
            }
            this.controller.load = new AbortController();
            this.loadingCompanies = true;
            axios.get('/companies', {
                signal: this.controller.load.signal
            }).then(response => {
                this.companies = response.data.data;
            }).catch(error => {
            }).finally(() => {
                this.loadingCompanies = false;
            })
        },

        close() {
            this.controller.save && this.controller.save.abort();
            this.controller.load && this.controller.load.abort();
            this.$emit('close', {saved: this.saved});
        },
        isDarkMode() {
            return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
        }
    },
    mounted() {
        this.loadCompanies();
    }
};
</script>

<template>
    <section>
        <div class="modal is-active">
            <div class="modal-background"></div>
            <div class="modal-card">
                <form @submit.prevent="save">
                    <header class="modal-card-head">
                        <p class="modal-card-title" v-if="!invoice || !invoice.id">{{ $t('invoices.labels.new') }}</p>
                        <p class="modal-card-title" v-if="invoice && invoice.id">{{ $t('invoices.labels.edit') }}</p>
                        <button class="delete" aria-label="close" @click="close"></button>
                    </header>
                    <section class="modal-card-body">

                        <b-field custom-class="mb-3" :label="$t('invoices.fields.company.name')" label-for="company"
                                 :type="errors.company_id ? 'is-danger' : null"
                                 :message="errors.company_id ? errors.company_id[0] : null">

                            <b-select :placeholder="$t('invoices.fields.company.placeholder')" expanded v-model="data.company_id"
                                      id="company" icon="domain" :loading="loadingCompanies">
                                <option v-bind:value="company.id" v-for="company in companies" :key="company.id">
                                    {{ company.name }}
                                </option>
                            </b-select>

                        </b-field>


                        <b-field :label="$t('invoices.fields.invoice_number.name')" custom-class="mb-3"
                                 label-for="invoice_number"
                                 :type="errors.invoice_number ? 'is-danger' : null"
                                 :message="errors.invoice_number ? errors.invoice_number[0] : null">
                            <b-input
                                required
                                v-model="data.invoice_number"
                                icon="cash-multiple"
                            ></b-input>
                        </b-field>

                        <b-field :label="$t('invoices.fields.issue_date.name')" custom-class="mb-3"
                                 label-for="issue_date"
                                 :type="errors.issue_date ? 'is-danger' : null"
                                 :message="errors.issue_date ? errors.issue_date[0] : null">

                            <DatePicker v-model="data.issue_date"
                                        :placeholder="$t('invoices.fields.issue_date.placeholder')"
                                        id="issue_date"
                                        />

                        </b-field>

                        <b-field :label="$t('invoices.fields.type.name')" custom-class="mb-3"
                                 label-for="type"
                                 :type="errors.type ? 'is-danger' : null"
                                 :message="errors.type ? errors.type[0] : null">
                            <b-select :label="$t('invoices.fields.type.placeholder')" v-model="data.type" id="type" required>
                                <option
                                    v-for="type in typeOptions"
                                    :value="type"
                                    :key="type">
                                    {{ $t('invoices.types.' + type) }}
                                </option>
                            </b-select>
                        </b-field>

                        <b-field :label="$t('invoices.fields.net_amount.name')" custom-class="mb-3"
                                 label-for="net_amount"
                                 :type="errors.net_amount ? 'is-danger' : null"
                                 :message="errors.net_amount ? errors.net_amount[0] : null">
                            <b-input
                                required
                                type="number"
                                step="0.01"
                                min="0"
                                v-model="data.net_amount"
                                icon="cash-multiple"
                            ></b-input>
                        </b-field>

                        <b-field :label="$t('invoices.fields.gross_amount.name')" custom-class="mb-3"
                                 label-for="gross_amount"
                                 :type="errors.gross_amount ? 'is-danger' : null"
                                 :message="errors.gross_amount ? errors.gross_amount[0] : null">
                            <b-input
                                required
                                type="number"
                                step="0.01"
                                min="0"
                                v-model="data.gross_amount"
                                icon="cash-multiple"
                            ></b-input>
                        </b-field>


                        <section class="mb-6 mt-6 is-flex is-flex-direction-column is-align-items-center">
                            <b-field :label="$t('invoices.fields.file.name')" custom-class="mb-3"
                                     label-for="file"
                                     :type="errors.file ? 'is-danger' : null"
                                     :message="errors.file ? errors.file[0] : null">
                                <FileInput v-model="file" :required="!invoice?.id" accept=".pdf"/>
                            </b-field>
                        </section>

                    </section>
                    <footer class="modal-card-foot">
                        <div class="buttons">
                            <button type="submit" v-bind:disabled="loading"
                                    v-bind:class="{'is-loading': loading}" class="button is-success">
                                {{ $t('actions.save')}}
                            </button>
                            <button class="button" @click.prevent="close">
                                {{ $t('actions.cancel') }}
                            </button>
                        </div>
                    </footer>
                </form>
            </div>
        </div>
    </section>
</template>
